import {Form, Formik} from 'formik';
import {useState} from 'react';
import {Modal} from 'react-bootstrap';
import {assets} from '../../../../../utils/assetsSrc';
import {
  lifeCyclePhasesEnum,
  taskStatusEnum,
} from '../../../../../utils/constants';
import MultiSelectDropdown from '../../../../../components/form/multiSelectDropdown/MultiSelectDropdown';
import Button from '../../../../../components/form/button/button';
import {toFilterArray} from '../../../../../utils/filterUtils';
import './filter.scss';

// an empty selection means "all"
const EMPTY_FILTERS = {
  life_cycle_phase: [],
  task_sub_categories: [],
  status: [],
};

export default function Filter({
  label,
  show,
  setShow,
  handleFilterChange,
  config,
  taskSubCategories,
}) {
  // the dropdown builds its menu once on mount, so reset has to remount it
  const [resetNonce, setResetNonce] = useState(0);

  const initialValues = {
    lifeCyclePhases: toFilterArray(config.life_cycle_phase)
      .map(id => lifeCyclePhasesEnum.find(item => item.id === id))
      .filter(Boolean),
    taskSubCategories: toFilterArray(config.task_sub_categories)
      .map(name => (taskSubCategories || []).find(item => item.name === name))
      .filter(Boolean),
    statuses: toFilterArray(config.status)
      .map(id => taskStatusEnum.find(item => item.id === id))
      .filter(Boolean),
  };

  const handleSubmit = vals => {
    handleFilterChange({
      life_cycle_phase: vals.lifeCyclePhases.map(item => item.id),
      task_sub_categories: vals.taskSubCategories.map(item => item.name),
      status: vals.statuses.map(item => item.id),
    });
  };

  const handleReset = () => {
    setResetNonce(nonce => nonce + 1);
    handleFilterChange(EMPTY_FILTERS);
  };

  const fields = [
    {
      name: 'lifeCyclePhases',
      label: 'Life cycle phases',
      listItems: lifeCyclePhasesEnum,
    },
    {
      name: 'taskSubCategories',
      label: 'Task subcategory',
      listItems: taskSubCategories || [],
    },
    {
      name: 'statuses',
      label: 'Status',
      listItems: taskStatusEnum,
    },
  ];

  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      aria-labelledby="filter"
      centered
      className="filter">
      <Modal.Body>
        <div className="header">
          <p className="label">{label}</p>
          <img
            onClick={() => setShow(false)}
            src={assets.closeIcon}
            alt="Close"
          />
        </div>
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          enableReinitialize>
          {({values, setFieldValue}) => (
            <Form>
              {fields.map(field => (
                <div className="user-multiselect" key={field.name}>
                  <MultiSelectDropdown
                    key={resetNonce}
                    label={field.label}
                    listItems={field.listItems}
                    name={field.name}
                    placeholder="-- Select --"
                    value={values[field.name]}
                    handleSelectedUsersChange={val => {
                      setFieldValue(field.name, val || []);
                    }}
                  />
                </div>
              ))}
              <div className="action-buttons">
                <Button
                  type="button"
                  clickHandler={handleReset}
                  variant="secondary-button">
                  Reset
                </Button>
                <Button type="submit" variant="submit-button">
                  Apply
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
}
